module.exports = __webpack_public_path__ + "static/media/bg-highlight.15032d29.png";